<div class="p-fluid p-form-widget">
  <div class="field pt-2 pb-4">
    <label class="pr-2">Date Request Received:</label>
    <div class="p-field-value">
      <p-date-picker
        [formControl]="dateTimeFaxReceived"
        [readonlyInput]="true"
        [showTime]="true"
        [showSeconds]="true"
        [showIcon]="true"
        [maxDate]="maxDate"
        [defaultDate]="maxDate"
        hourFormat="12"
        appendTo="body"
      ></p-date-picker>
    </div>
  </div>
</div>
<div class="flex justify-end">
  <button
    pButton
    label="OK"
    [disabled]="dateTimeFaxReceived.invalid"
    (click)="onClose()"
  ></button>
</div>

